import { render, staticRenderFns } from "./noticeDetails.vue?vue&type=template&id=2e23bfc5&scoped=true&"
import script from "./noticeDetails.vue?vue&type=script&lang=js&"
export * from "./noticeDetails.vue?vue&type=script&lang=js&"
import style0 from "./noticeDetails.vue?vue&type=style&index=0&id=2e23bfc5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e23bfc5",
  null
  
)

export default component.exports